import { AppRoutes } from './AppRoutes';
import { USER_PILLARS } from './interfaces';

import type { ILaunchpadLane } from './interfaces/ILaunchpadLane';

const LAUNCHPAD_LANES: ILaunchpadLane[] = [
  {
    id: 'visualize',
    stageNum: 1,
    titleI18nKey: 'launchpad.lanes.visualize.title',
    subtitleI18nKey: 'launchpad.lanes.visualize.subtitle',
    tiles: [
      {
        id: 'map',
        i18nKey: 'launchpad.tiles.map',
        iconKey: 'route-tracking',
        status: 'live',
        route: AppRoutes.valueChainMap,
        pillarKey: USER_PILLARS.valueChainAssessment,
      },
      {
        id: 'discover',
        i18nKey: 'launchpad.tiles.discover',
        iconKey: 'network-ai',
        status: 'future',
        action: 'discover',
        pillarKey: USER_PILLARS.valueChainAssessment,
      },
      {
        id: 'collaborate',
        i18nKey: 'launchpad.tiles.collaborate',
        iconKey: 'inbound-consolidation',
        status: 'future',
      },
    ],
  },
  {
    id: 'understand',
    stageNum: 2,
    titleI18nKey: 'launchpad.lanes.understand.title',
    subtitleI18nKey: 'launchpad.lanes.understand.subtitle',
    tiles: [
      {
        id: 'finance', i18nKey: 'launchpad.tiles.finance', iconKey: 'financial-risk-roi', status: 'future',
      },
      {
        id: 'reputation', i18nKey: 'launchpad.tiles.reputation', iconKey: 'system-health', status: 'future',
      },
      {
        id: 'ownership', i18nKey: 'launchpad.tiles.ownership', iconKey: 'structure-pyramid', status: 'future',
      },
      {
        id: 'regulation', i18nKey: 'launchpad.tiles.regulation', iconKey: 'compliance-document', status: 'future',
      },
      {
        id: 'climate', i18nKey: 'launchpad.tiles.climate', iconKey: 'sustainability', status: 'future',
      },
    ],
  },
  {
    id: 'plan',
    stageNum: 3,
    titleI18nKey: 'launchpad.lanes.plan.title',
    subtitleI18nKey: 'launchpad.lanes.plan.subtitle',
    tiles: [
      {
        id: 'scenario', i18nKey: 'launchpad.tiles.scenario', iconKey: 'decision-flow', status: 'future',
      },
      {
        id: 'prioritize', i18nKey: 'launchpad.tiles.prioritize', iconKey: 'data-trends', status: 'future',
      },
    ],
  },
  {
    id: 'act',
    stageNum: 4,
    titleI18nKey: 'launchpad.lanes.act.title',
    subtitleI18nKey: 'launchpad.lanes.act.subtitle',
    tiles: [
      {
        id: 'awareness', i18nKey: 'launchpad.tiles.awareness', iconKey: 'monitoring-radar', status: 'future',
      },
      {
        id: 'sourcing', i18nKey: 'launchpad.tiles.sourcing', iconKey: 'outbound-distribution', status: 'future',
      },
      {
        id: 'competitors', i18nKey: 'launchpad.tiles.competitors', iconKey: 'supply-chain-node', status: 'future',
      },
    ],
  },
  {
    id: 'reporting',
    titleI18nKey: 'launchpad.lanes.reporting.title',
    subtitleI18nKey: 'launchpad.lanes.reporting.subtitle',
    tiles: [
      {
        id: 'board-report', i18nKey: 'launchpad.tiles.boardReport', iconKey: 'compliance-document', status: 'future',
      },
      {
        id: 'exec-summary', i18nKey: 'launchpad.tiles.execSummary', iconKey: 'data-trends', status: 'future',
      },
      {
        id: 'report-builder', i18nKey: 'launchpad.tiles.reportBuilder', iconKey: 'layers', status: 'future',
      },
      {
        id: 'templated-reports',
        i18nKey: 'launchpad.tiles.templatedReports',
        iconKey: 'compliance-document',
        status: 'future',
      },
      {
        id: 'materiality',
        i18nKey: 'launchpad.tiles.materiality',
        iconKey: 'health-tech-ecg',
        status: 'live',
        route: AppRoutes.materialityAssessment,
        pillarKey: USER_PILLARS.materialityAssessment,
      },
    ],
  },
];

export function getLaunchpadLanes(): ILaunchpadLane[] {
  return LAUNCHPAD_LANES;
}

export function getLaunchpadTileCount(): number {
  return LAUNCHPAD_LANES.reduce((count, lane) => count + lane.tiles.length, 0);
}

export default LAUNCHPAD_LANES;
